<template>
  <div>
    <v-data-table
      class="run-item-table"
      v-model="selected"
      :headers="headers"
      :items="items"
      :disable-pagination="true"
      :hide-default-footer="true"
      :loading="loading"
      item-key="name"
      @click:row="onItemClick"
      height="600px"
      dense
    >
      <template v-slot:item.publish_date="{ item }">
        {{ $moment(item.publish_date).format() }}
      </template>
      <template v-slot:item.is_valid="{ item }">
        <v-icon class="green--text" title="Публикация прошла проверку" v-if="item.is_valid">
          done
        </v-icon>
        <v-icon class="orange--text" title="Публикация не прошла проверку" v-else>
          error
        </v-icon>
      </template>
    </v-data-table>
    <v-pagination
      :value="page"
      :length="pages"
      :total-visible="10"
      @input="onPageChange"
    ></v-pagination>
    <v-dialog v-model="dialog" max-width="60%">
      <result-card :item="item"></result-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import ResultCard from '@/components/spiders/results/result-card'

export default Vue.extend({
  components: {
    ResultCard,
  },
  props: {
    'items': Array,
    'page': Number,
    'pages': Number,
    'loading': Boolean,
  },
  data: () => ({
    dialog: false,
    item: null,
    selected: [],
    headers: [
      {
        text: 'URL',
        align: 'start',
        value: 'url',
        width: '250px',
      },
      {
        text: 'Заголовок',
        align: 'start',
        value: 'title',
      },
      {
        text: 'Дата',
        value: 'publish_date',
        width: '150px',
      },
      {
        value: 'is_valid',
        width: '60px',
      },
    ],
  }),
  methods: {
    onItemClick(item) {
      this.item = item
      this.dialog = true
    },
    onPageChange(page) {
      this.$emit('page-change', page)
    },
  },
})
</script>
<style scoped>
.run-item-table {
  cursor: pointer;
}
</style>
